// When changing this file, also adjust backend/src/data/betriebsanweisungVocab.ts
//
// The three Betriebsanweisung types. Each has a theme color (border + section
// bars), an optional legal subtitle, and a LOCKED set of section titles (per the
// official templates). Only the bullets/symbols inside each section are editable.

export const BA_TYPES = [
  {
    value: "machine",
    labelKey: "betriebsanweisung.types.machine",
    color: "#1414e6",
    subtitle: "",
    sections: [
      { key: "anwendungsbereich", title: "Anwendungsbereich" },
      { key: "gefahren", title: "Gefahren für Mensch und Umwelt" },
      { key: "schutzmassnahmen", title: "Schutzmaßnahmen und Verhaltensregeln" },
      { key: "stoerungen", title: "Verhalten bei Störungen" },
      { key: "ersteHilfe", title: "Erste Hilfe" },
      { key: "instandhaltung", title: "Instandhaltung" },
    ],
  },
  {
    value: "dangerousGoods",
    labelKey: "betriebsanweisung.types.dangerousGoods",
    color: "#ec6608",
    subtitle: "gem. GefStoffV",
    sections: [
      { key: "gefahrstoffbezeichnung", title: "Gefahrstoffbezeichnung" },
      { key: "gefahren", title: "Gefahren für Mensch und Umwelt" },
      { key: "schutzmassnahmen", title: "Schutzmaßnahmen und Verhaltensregeln" },
      { key: "gefahrfall", title: "Verhalten im Gefahrfall" },
      { key: "ersteHilfe", title: "Erste Hilfe" },
      { key: "entsorgung", title: "Sachgerechte Entsorgung" },
    ],
  },
  {
    value: "biological",
    labelKey: "betriebsanweisung.types.biological",
    color: "#1c8a3b",
    subtitle: "gem. BioStoffV",
    sections: [
      { key: "anwendungsbereich", title: "Anwendungsbereich" },
      { key: "gefahren", title: "Gefahren für Mensch und Umwelt" },
      { key: "schutzmassnahmen", title: "Schutzmaßnahmen und Verhaltensregeln" },
      { key: "gefahrfall", title: "Verhalten im Gefahrfall" },
      { key: "ersteHilfeGesundheit", title: "Erste Hilfe und Gesundheitsschutz" },
      { key: "entsorgung", title: "Sachgerechte Entsorgung" },
    ],
  },
];

export function baTypeConfig(type) {
  return BA_TYPES.find((t) => t.value === type) || BA_TYPES[0];
}

// Fresh section list for a type: locked title/key, empty bullets/symbols.
export function defaultSectionsForType(type) {
  return baTypeConfig(type).sections.map((s) => ({
    key: s.key,
    title: s.title,
    bullets: [""],
    symbols: [],
  }));
}
